import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getSaleFromName, ISaleItem } from '../../data/SaleList';
import HeartBeatsSalePage from './HeartBeats';
import RoboClashSalePage from './RoboClash';

const SalePageRoute = (props: RouteComponentProps<any>) => {
    const saleData = getSaleFromName(props.match.params.saleName);
    if (!saleData) {
        props.history.replace('/');
        return <></>;
    }

    const renderSalePage = () => {
        switch (saleData.name) {
            case "heartBeats":
                return <HeartBeatsSalePage saleData={saleData} />
            case "roboClash":
                return <RoboClashSalePage saleData={saleData} />
            default:
                return <></>
        }
    }

    return renderSalePage()

};
export default SalePageRoute;